import { FormGroup } from "@angular/forms";
import { IdNameObjectType } from "../../state/models/global-configuration-state.model";
import { ACUITY_TYPES_ORIGIN_LIST } from "./product-constant";
import { TrackingSystemConfigurationInfo } from "./product.model";

const acuitySelected = function(control, jsonModelService: any) {
	const acuityEnabled = jsonModelService.FindValue('enabled');

	return acuityEnabled || false;
};

const integrationAcuityEnabled = function(control, jsonModelService: any) {
	const acuityEnabled = jsonModelService.FindValue('enabled');
	const nexsysEnabled = jsonModelService.FindRootValue('nexsys.enabled');
	const valutrustEnabled = jsonModelService.FindRootValue('valutrust.enabled');
	const xpanseEnabled = jsonModelService.FindRootValue('xpanse.enabled');
	const integrationEnabled = jsonModelService.FindRootValue('integration.enabled');

	return (acuityEnabled && (nexsysEnabled || valutrustEnabled || xpanseEnabled || integrationEnabled)) || false;
};

export const ACUITY_FORM_CONFIG = {
	acuity: {
		enabled: {
			path: 'acuity.enabled',
			DataType: 'Boolean',
			DisplayText: `Acuity`,
			Name: 'enabled',
			customClass: 'product-form-switch',
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					const setAcuity = new TrackingSystemConfigurationInfo();
					if ($event.checked) {
						formGroup.get('acuity')?.setValue({ ...setAcuity, enabled: true });
					} else {
						formGroup.get('acuity')?.setValue({ ...setAcuity });
					}
					formGroup.get('acuity')?.updateValueAndValidity();
				},
			},
		},
		instance: {
			DataType: 'Selector',
			path: 'acuity.instance',
			UIControl: 'Dropdown',
			DisplayText: 'Acuity Instance',
			label: 'Acuity Instance',
			Name: 'instance',
			required: false,
			customClass: 'product-form-dropdown',
			Visible: acuitySelected,
			isRequired: function(control, jsonModelService: any) {
				const acuityEnabled = jsonModelService.FindValue('enabled');
				return jsonModelService.IsEmpty() && acuityEnabled;
			},
			options: ACUITY_TYPES_ORIGIN_LIST.map((item: IdNameObjectType) => {
				return {
					label: item.name,
					value: item.id,
				};
			}),
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('acuity').updateValueAndValidity();
				}
			}
		},
		productName: {
			path: 'acuity.productName',
			DataType: 'String',
			DisplayText: `Acuity`,
			Name: 'productName',
			customClass: 'product-form-switch',
			hidden: true,
			required: false
		},
		productId: {
			DataType: 'Selector',
			path: 'acuity.productId',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			customClass: 'product-form-dropdown',
			options: [],
			isRequired: function(control, jsonModelService: any) {
				const acuityEnabled = jsonModelService.FindValue('enabled');
				return jsonModelService.IsEmpty() && acuityEnabled;
			},
			UIOptions: {
				ShowClearButton: true,
				ShowFilter: true,
				showLabel: true,
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexJobOption = formConfigModel.options.findIndex(element => element.value === value);
						const jobOption = formConfigModel.options[ indexJobOption ];
						formGroup.get('acuity.productName')?.setValue(jobOption?.label);
					} else {
						formGroup.get('acuity.productId')?.setValue(null);
						formGroup.get('acuity.productName')?.setValue(null);
					}

				},
			},
		},
		disableCommunications: {
			path: 'acuity.disableCommunications',
			DataType: 'Boolean',
			DisplayText: 'Disable Acuity communication with the provider',
			Name: 'disableCommunications',
			customClass: 'product-form-switch ms-5 mb-4 mt-4',
			Visible: integrationAcuityEnabled,
			required: false
		},
		bpoProduct: {
			path: 'acuity.bpoProduct',
			DataType: 'Boolean',
			DisplayText: `Is BPO product`,
			Name: 'bpoProduct',
			customClass: 'product-form-switch ms-5 mt-4',
			required: false,
			defaultValue: false,
			Visible: acuitySelected,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('acuity.bpoLinkTrigger')?.setValue(null);
					formGroup.get('acuity')?.updateValueAndValidity();
				},
			},
		},
		bpoLinkTrigger: {
			DataType: 'Selector',
			path: 'acuity.bpoLinkTrigger',
			UIControl: 'Dropdown',
			DisplayText: 'Add DM link when:',
			label: 'Add DM link when:',
			Name: 'bpoLinkTrigger',
			options: [],
			customClass: 'mt-3',
			isRequired: function(control, jsonModelService: any) {
				return jsonModelService.IsEmpty() && jsonModelService.FindValue('bpoProduct');
			},
			Visible: function(control, formModelService: any) {
				const bpoEnabled = formModelService.FindValue('bpoProduct');
				const acuityEnabled = formModelService.FindValue('enabled');

				return bpoEnabled && acuityEnabled;
			},
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			}
		},
		is3dProduct: {
			path: 'acuity.is3dProduct',
			DataType: 'Boolean',
			DisplayText: `Is 3D product (If 3D Active, please Enable Inspection below)`,
			Name: 'is3dProduct',
			customClass: 'product-form-switch ms-5 mb-4 mt-4',
			required: false,
			Visible: function(control, jsonModelService: any) {
				const acuityEnabled = jsonModelService.FindValue('enabled');
				const enableHandheld = jsonModelService.FindRootValue('enableHandheld')
				return acuityEnabled && !enableHandheld;
			},
		},
		invoice: {
			path: 'acuity.invoice',
			DataType: 'Boolean',
			DisplayText: `Invoice`,
			Name: 'invoice',
			customClass: 'product-form-switch ms-5',
			required: false,
			Visible: acuitySelected,
		},
		notifyAppscopeAcuityOrderEscalated: {
			path: 'acuity.notifyAppscopeAcuityOrderEscalated',
			DataType: 'Boolean',
			DisplayText: `Notify Appscope when order gets escalated on codes (104-201)`,
			Name: 'notifyAppscopeAcuityOrderEscalated',
			customClass: 'product-form-switch ms-5 mt-4',
			required: false,
			UIOptions: {
				showLabel: true,
				SwitchComponentOptions: {
					removeLinkLabel: true,
				},
			},
			Visible: function(control, jsonModelService: any) {
				const originValue = jsonModelService.FindRootValue('origin');

				return originValue === 'AppScope' || false;
			}
		},
		productAssetsId: {
			DataType: 'Selector',
			path: 'acuity.productAssetsId',
			UIControl: 'Dropdown',
			DisplayText: 'Assets on Completion',
			label: 'Assets on Completion',
			Name: 'productAssetsId',
			customClass: 'product-form-dropdown',
			options: [],
			required: false,
			Visible: function(control, jsonModelService: any) {
				return jsonModelService.FindValue('enabled')
					&& jsonModelService.FindRootValue('integration.enabled')
					&& jsonModelService.FindRootValue('integration.integrationId');
			},
			UIOptions: {
				ShowClearButton: true,
				ShowFilter: true,
				showLabel: true,
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[ indexOption ];
						formGroup.get('acuity.productAssetDescription')?.setValue(option.label);
					} else {
						formGroup.get('acuity.productAssetsId')?.setValue(null);
						formGroup.get('acuity.productAssetDescription')?.setValue(null);
					}

				},
			},
		},
		productAssetDescription: {
			path: 'acuity.productAssetDescription',
			DataType: 'String',
			DisplayText: '',
			Name: 'productAssetDescription',
			hidden: true,
			required: false
		},
		autoCompleteScopeOrderOption: {
			autoComplete: {
				path: 'acuity.autoCompleteScopeOrderOption.autoComplete',
				DataType: 'Boolean',
				DisplayText: `Auto complete appscope order when milestone is:`,
				Name: 'acuity.autoCompleteScopeOrderOption.autoComplete',
				customClass: 'product-form-switch ms-5 mb-4',
				required: false,
				UIOptions: {
					showLabel: true,
					SwitchComponentOptions: {
						removeLinkLabel: true,
					},
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
						if (formGroup.get('acuity.autoCompleteScopeOrderOption.autoComplete')?.value) {
							formGroup.get('acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger')?.setValue('');
						}
						formGroup.get('acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger')?.updateValueAndValidity();
						formGroup.get('acuity.autoCompleteScopeOrderOption')?.updateValueAndValidity();
					},
				},
			},
			autoCompleteMilestoneTrigger: {
				DataType: 'Selector',
				path: 'acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger',
				UIControl: 'Dropdown',
				DisplayText: 'Milestone',
				label: 'Milestone',
				Name: 'autoCompleteMilestoneTrigger',
				customClass: 'product-form-dropdown mb-4',
				options: [],
				isRequired: function(control, jsonModelService: any) {
					return jsonModelService.IsEmpty() && jsonModelService.FindValue('autoComplete');
				},
				Visible: function(control, jsonModelService: any) {
					return jsonModelService.FindValue('autoComplete');
				},
				UIOptions: {
					ShowClearButton: true,
					ShowFilter: true,
					showLabel: true,
				}
			},
			uploadDocuments: {
				path: 'acuity.autoCompleteScopeOrderOption.uploadDocuments',
				DataType: 'Boolean',
				DisplayText: `Upload documents inside origin when milestone is:`,
				label: `Upload documents inside origin when milestone is:`,
				Name: 'uploadDocuments',
				customClass: 'product-form-switch ms-5',
				required: false,
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
						if (formGroup.get('acuity.autoCompleteScopeOrderOption.uploadDocuments')?.value) {
							formGroup.get('acuity.autoCompleteScopeOrderOption.uploadDocumentsMilestone')?.setValue('');
						}
						formGroup.get('acuity.autoCompleteScopeOrderOption.autoCompleteMilestoneTrigger')?.updateValueAndValidity();
						formGroup.get('acuity').updateValueAndValidity();
					},
				},
				UIOptions: {
					showLabel: true,
					SwitchComponentOptions: {
						removeLinkLabel: true,
					},
				},
			},
			uploadDocumentsMilestone: {
				DataType: 'Selector',
				path: 'acuity.autoCompleteScopeOrderOption.uploadDocumentsMilestone',
				UIControl: 'Dropdown',
				DisplayText: 'Milestone',
				label: 'Milestone',
				Name: 'uploadDocumentsMilestone',
				customClass: 'mt-4',
				options: [],
				isRequired: function(control, jsonModelService: any) {
					return jsonModelService.IsEmpty() && jsonModelService.FindValue('uploadDocuments');
				},
				UIOptions: {
					ShowClearButton: true,
					ShowFilter: true,
					showLabel: true,
				},
				Visible: function(control, jsonModelService: any) {
					return jsonModelService.FindValue('uploadDocuments');
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
						formGroup.get('acuity').updateValueAndValidity();
					},
				},
			},
			documents: {
				DataType: 'Array',
				path: 'acuity.autoCompleteScopeOrderOption.documents',
				Name: 'documents',
				DisplayText: '',
				ButtonText: 'Add Document',
				child: [],
				required: false,
				Visible: function(control, jsonModelService: any) {
					return jsonModelService.FindValue('uploadDocuments');
				},
				extradata: null,
				childFormBuilderConfig: {
					documentSource: {
						DataType: 'Selector',
						UIControl: 'Dropdown',
						DisplayText: 'Select a Source',
						Name: 'source',
						customClass: 'document-dropdown-form',
						required: false,
						options: [

							{
								label: 'Appscope',
								value: 'Appscope'
							},
							{
								label: 'Acuity',
								value: 'Acuity'
							},
							{
								label: 'Class',
								value: 'Class'
							},
							{
								label: 'cmpacuity',
								value: 'cmpacuity'
							}

						],
						UIOptions: {
							ShowClearButton: true,
							ShowLabel: false
						},
						UIEvents: {
							onChange: ($event: any, model: any, formGroup: any, extraData: any, fieldOptions?: any) => {
								model[ 'acuity' ][ 'autoCompleteScopeOrderOption' ][ 'documents' ][ 'child' ][ fieldOptions.index ][ 'documentType' ].options = [];

								if ($event.value) {
									const parsedData = extraData[ $event.value.toLowerCase() ].map((item: IdNameObjectType) => {
										return {
											label: item.name,
											value: item.id,
										};
									});
									model[ 'acuity' ][ 'autoCompleteScopeOrderOption' ][ 'documents' ][ 'child' ][ fieldOptions.index ][ 'documentType' ].options = parsedData;

									const formArray = formGroup?.get('acuity.autoCompleteScopeOrderOption.documents');
									if (formGroup && formArray && formArray.at(fieldOptions.index)?.get('documentType')) {
										if ($event.value) {
											formArray.at(fieldOptions.index).get('documentType').enable();
										} else {
											formArray.at(fieldOptions.index).get('documentType').disable();
										}
										const siblingValue = formArray.at(fieldOptions.index)?.get('documentType')?.value;

										const indexSiblingSelected = parsedData.findIndex(element => element.value === siblingValue);

										if (indexSiblingSelected < 0) {
											formArray.at(fieldOptions.index).get('documentType')?.setValue(null);
										}
									}

								}
							}
						}
					},
					documentType: {
						DataType: 'Selector',
						DisplayText: 'Select a Document Type',
						Name: 'documentType',
						UIControl: 'Dropdown',
						customClass: 'document-dropdown-form',
						required: false,
						options: [],
						UIOptions: {
							ShowClearButton: true,
							ShowLabel: false
						}
					},
					isFinalDocument: {
						DataType: 'Boolean',
						DisplayText: 'Is final Document?',
						defaultValue: false,
						Name: 'isFinalDocument',
						customClass: 'product-form-switch',
						required: false
					}
				},
			}
		}
	}
};
